module.exports = __webpack_public_path__ + "img/postbox-image.b4681f73.svg";